export default "__VITE_ASSET__DEge6JJl__"